import { avoir } from "locales/fr/avoir";
import { login } from "locales/fr/login";
import { payment } from "locales/fr/payment";
import { register } from "locales/fr/register";
import { alert } from "./alert";
import { app } from "./app";
import { client } from "./client";
import { congeList } from "./congeList";
import { contrats } from "./contrat";
import { cra } from "./cra";
import { depense } from "./depense";
import { expense } from "./expense";
import { ged } from "./ged";
import { home } from "./home";
import { invoice } from "./invoice";
import { sidebar } from "./navItems";
import { offer } from "./offer";
import { pack } from "./pack";
import { profile } from "./profile";
import { projects } from "./project";
import { quote } from "./quote";
import { role } from "./role";
import { signature } from "./signature";
import { supplier } from "./supplier";
import { users } from "./users";

import { craList } from "./cra";
import { supplierConsult } from "./supplierConsult";
import { supplierUser } from "./supplierUser";
import { absences } from "./absences";
import { leaveRequest } from "./leaveRequest";
import { timesheet } from "./timesheet";

export const fr = {
  home: home,
  invoice: invoice,
  login: login,
  register: register,
  payment: payment,
  quote: quote,
  avoir: avoir,
  sidebar: sidebar,
  expense: expense,
  offer: offer,
  app: app,
  supplier: supplier,
  client: client,
  depense: depense,
  role: role,
  users: users,
  signature: signature,
  ged: ged,
  contrats: contrats,
  alert,
  congeList: congeList,
  projects: projects,
  cra,
  pack,
  profile,

  supplierConsult: supplierConsult,
  supplierUser: supplierUser,
  absences: absences,
  leaveRequest: leaveRequest,
  timesheet: timesheet,
};
